(() => {
  if (
    !window.swinger
    || !window.swinger.config
    || !window.swinger.config.mediaqueries
  ) {
    return;
  }

  const breakpoint = window.matchMedia(window.swinger.config.mediaqueries.smallerThanDesktop);
  let isSmall = breakpoint.matches;

  breakpoint[breakpoint.addEventListener ? 'addEventListener' : 'addListener']('change', (e) => {
    isSmall = e.matches;
  });

  window.swinger.observer.initialize('.swinger-header__metanav-item-cart', (elem) => {
    let cartItemsCount;

    const update = () => {
      const cartItems = window.swinger.user.getCartItems();
      if (cartItems && cartItems.length) {
        const count = cartItems.reduce((acc, item) => acc + (item.quantity || 1), 0);
        elem.setAttribute('data-itemcount', count > 99 ? '99+' : count);
        if (cartItemsCount !== undefined && cartItemsCount !== count) {
          window.swinger.i18n()
            .then((i18n) => {
              window.swinger.a11y.notify(i18n('ui.header.cart.itemcount.items', {
                totalCount: count,
              }));
            })
            .catch(console.info);
        }
        cartItemsCount = count;
      } else {
        elem.removeAttribute('data-itemcount');
        if (cartItemsCount !== undefined && cartItemsCount !== cartItems.length) {
          window.swinger.i18n()
            .then((i18n) => {
              window.swinger.a11y.notify(i18n('ui.header.cart.itemcount.no-items'));
            })
            .catch(console.info);
        }
        cartItemsCount = 0;
      }
    };

    document.addEventListener('swinger.user:authchange', update);

    update();
  }, false);

  window.swinger.observer.initialize('#swinger-login__wrapper-login', (elem) => {
    window.swinger.visibility.observe(elem, (isVisible) => {
      window.setTimeout(() => {
        window.swinger.overlayManager[isVisible ? 'register' : 'unregister'](elem, () => {
          (
            document.querySelector('#header-button-login')
            || document.querySelector('#swinger-usermenu__toggle')
            || document.body
          ).focus();
          window.swinger.visibility.hide(elem);
        }, undefined, true);
      });
    });
  }, false);

  window.swinger.observer.initialize('#swinger-navigation__toggle', (elem) => {
    window.swinger.visibility.observe(elem, (isVisible) => {
      if (!isVisible && document.activeElement === elem) {
        (document.querySelector('#header-home-link') || document.body).focus();
      }
    });
  }, false);

  window.swinger.eventHub.register('mouseleave', '.swinger-navigation-item--has-submenu', (e) => {
    if (isSmall) {
      return;
    }

    const elem = window.swinger.eventHub.getTarget(e);
    const submenu = elem.querySelector('.swinger-navigation-item__submenu');
    const id = submenu.getAttribute('id');

    if (id) {
      const controllingElements = window.swinger.$(`[aria-controls~="${id}"]`);

      if (controllingElements.length) {
        controllingElements.forEach((elem) => {
          elem.setAttribute('aria-expanded', 'false');
        });
      }

      if (submenu.contains(document.activeElement)) {
        controllingElements[0].focus();
      }
    }

    window.swinger.visibility.hide(submenu, true);
  });

  const elemVisibility = window.WeakMap ? new WeakMap() : new Map();

  const handleBasedOnMQ = (elem, startsVisible, closeFn, useFirstChildForVisibility = false) => {
    window.swinger.visibility[startsVisible ? 'show' : 'hide'](elem);

    const handleVisibilityChange = () => {
      const isVisible = !!elemVisibility.get(elem);

      switch (true) {
        default:
          break;

        case (!isSmall && isVisible):
          window.swinger.overlayManager.unregister(elem);
          window.swinger.visibility.show(elem, true);
          break;

        case (!isSmall && !isVisible):
          window.swinger.overlayManager.unregister(elem);
          window.swinger.visibility.hide(elem, true);
          break;

        case (isSmall && isVisible):
          window.swinger.overlayManager.register(elem, closeFn, undefined, true);
          break;

        case (isSmall && !isVisible):
          window.swinger.overlayManager.unregister(elem);
          window.swinger.visibility.hide(elem);
          break;
      }
    };

    breakpoint[breakpoint.addEventListener ? 'addEventListener' : 'addListener']('change', () => {
      handleVisibilityChange();
    });

    const children = elem.children;
    const elemToObserve = useFirstChildForVisibility && children.length ? children[0] : elem;

    window.swinger.visibility.observe(elemToObserve, (isVisible) => {
      elemVisibility.set(elem, isVisible);
      handleVisibilityChange();
    });
  };

  window.swinger.observer.initialize('.swinger-navigation-item > .swinger-navigation-item__submenu', (elem) => {
    const closeFn = () => {
      switch (true) {
        default:
          try {
            elem.closest('.swinger-navigation-item').querySelector('.swinger-navigation-item__toggle').focus();
          } catch (e) {
            try {
              document.querySelector('#swinger-navigation__toggle').focus();
            } catch (e) {
              (document.querySelector('#header-home-link') || document.body).focus();
            }
          }
          break;

        case !elem.contains(document.activeElement):
          break;
      }

      window.swinger.visibility.hide(elem);
    };

    handleBasedOnMQ(elem, false, closeFn);
  }, false);

  window.swinger.observer.initialize('.swinger-navigation__panel', (elem) => {
    const closeFn = () => {
      switch (true) {
        default:
          (document.querySelector('#header-home-link') || document.body).focus();
          break;

        case !elem.contains(document.activeElement):
          break;

        case isSmall:
          document.querySelector('#swinger-navigation__toggle').focus();
          break;
      }
      window.swinger.visibility.hide(elem);
    };

    handleBasedOnMQ(elem, !isSmall, closeFn, true);
  }, false);

  window.swinger.eventHub.register('mouseleave', '.swinger-usermenu', (e) => {
    if (isSmall) {
      return;
    }

    const elem = window.swinger.eventHub.getTarget(e);
    const submenu = elem.querySelector('.swinger-usermenu__list');
    const id = submenu.getAttribute('id');

    if (id) {
      const controllingElements = window.swinger.$(`[aria-controls~="${id}"]`);

      if (controllingElements.length) {
        controllingElements.forEach((elem) => {
          elem.setAttribute('aria-expanded', 'false');
        });
      }

      if (submenu.contains(document.activeElement)) {
        controllingElements[0].focus();
      }
    }

    window.swinger.visibility.hide(submenu);
  });

  window.swinger.observer.initialize('.swinger-usermenu__list', (elem) => {
    const closeFn = () => {
      switch (true) {
        default:
          document.querySelector('#swinger-usermenu__toggle').focus();
          break;

        case !elem.contains(document.activeElement):
          break;

        case isSmall:
          document.querySelector('#header-button-login').focus();
          break;
      }
      window.swinger.visibility.hide(elem);
    };

    handleBasedOnMQ(elem, false, closeFn);

    breakpoint[breakpoint.addEventListener ? 'addEventListener' : 'addListener']('change', (e) => {
      if (!e.matches) {
        window.swinger.visibility.show(elem);
      }
    });
  }, false);

  window.swinger.eventHub.register('keydown', '.swinger-header__metanav-item-link[for="search"]', (e) => {
    if (e.key !== 'Enter' && e.key !== ' ') {
      return;
    }

    const elem = window.swinger.eventHub.getTarget(e).closest('.swinger-header__metanav-item-link[for="search"]');
    const inputId = elem.getAttribute('for');
    const input = document.querySelector(`#${inputId}`);

    input.focus();

    e.preventDefault();
  });

  /* The following allows for cursor navigation in between all currently visible menu items */
  window.swinger.navigationHelper.enableArrowNav('.swinger-header');
})();
